'use strict';

import {EwSiteApp} from '../../app/ewsiteapp';
import { Fancybox } from "@fancyapps/ui";
import { computeGasConnection } from './gasPriceCalc';

EwSiteApp.controller('gasConnectCalcCtrl', ['$scope', function ($scope) {
		// Forma visada matoma; rezultatas / įspėjimas / klaida rodomi inline per calcState.
		$scope.calcState = 'idle'; // 'idle' | 'result' | 'warning' | 'error'
		$scope.distanceInput = '';
		$scope.distance = '';
		$scope.distanceLabel = '';
		$scope.priceWithoutVat = '';
		$scope.priceWithVat = '';
		$scope.errorMsg = '';

		var rates = tariffs_data.rates;
		var vatPercent = tariffs_data.vat_percent;
		var distanceMax = tariffs_data.distance_max;
		var regia_domain = tariffs_data.regia_domain;
		var regia_params = tariffs_data.regia;
		var distance_url = tariffs_data.distance_url;
		var translations = tariffs_data.translations;

		this.cache = {};
		var self = this;

		this.getT = function (msg) {
			if (typeof (translations[msg]) === 'undefined') {
				return '*' + msg + '*';
			}
			return translations[msg];
		};

		$('body').on('click', '.municipality', function () {
			openRegiaByMunicipality($(this).data('key'));
		});

		$("#distance_by_gps a").click(function (e) {
			e.preventDefault();
			openRegiaByGps();
		});

		function hasSeparator(str) {
			return /[.,]/.test(str);
		}

		// FR-2.2: keypress — leidžia tik 0-9 ir vieną dešimtainį skirtuką (. arba ,)
		$scope.validateInput = function (event) {
			var charCode = (event.which) ? event.which : event.keyCode;
			var ch = String.fromCharCode(charCode);
			var current = $('#distance').val();
			$scope.errorMsg = '';

			if (ch >= '0' && ch <= '9') {
				return;
			}
			if (ch === '.' || ch === ',') {
				if (hasSeparator(current)) {
					event.preventDefault();
				}
				return;
			}
			event.preventDefault();
		};

		// FR-2.2: paste — pašalina neleistinus simbolius, leidžia tik pirmąjį separatorių
		$scope.sanitizePaste = function (event) {
			event.preventDefault();
			var clipboard = (event.originalEvent || event).clipboardData;
			if (!clipboard) {
				return;
			}
			var pasted = clipboard.getData('text') || '';
			var cleaned = pasted.replace(/[^0-9.,]/g, '');
			// palikti tik 1-ą separatorių
			var firstSep = cleaned.search(/[.,]/);
			if (firstSep !== -1) {
				cleaned = cleaned.substring(0, firstSep + 1) + cleaned.substring(firstSep + 1).replace(/[.,]/g, '');
			}
			var input = document.getElementById('distance');
			var start = input.selectionStart || 0;
			var end = input.selectionEnd || 0;
			var existing = input.value;
			var newValue = existing.substring(0, start) + cleaned + existing.substring(end);
			// papildoma apsauga: jei po įklijavimo atsirado 2 separatoriai, pašalinti antrąjį
			var sepIdx = newValue.search(/[.,]/);
			if (sepIdx !== -1) {
				newValue = newValue.substring(0, sepIdx + 1) + newValue.substring(sepIdx + 1).replace(/[.,]/g, '');
			}
			input.value = newValue;
			$scope.$applyAsync(function () {
				$scope.distanceInput = newValue;
			});
		};

		$scope.resetCalculator = function () {
			$scope.distanceInput = '';
			$scope.distance = '';
			$scope.distanceLabel = '';
			$scope.priceWithoutVat = '';
			$scope.priceWithVat = '';
			$scope.errorMsg = '';
			$scope.calcState = 'idle';
		};

		function openRegiaByMunicipality(key) {
			var municipality = key;
			if (!municipality) {
				return false;
			}
			var url = regia_domain + (regia_params.municipality_path.replace('%MUNI%', municipality));
			const instance = Fancybox.getInstance();
			if (instance) {
				instance.close();
			}
			openRegiaIframe(url);
		}

		function openRegiaIframe(url) {
			showLoading('loading_regia_map');
			Fancybox.show([{
					type: 'iframe',
					src: url,
					width: '100%',
					autoSize: false,
					autoHeight: true,
					autoWidth: false,
					fitToView: true,
					closeButton: false,
					on: {
						init: () => {
							hideLoading('loading_regia_map');
							document.body.style.overflowY = "hidden";
							document.body.style.position = "fixed";
						},
						destroy: () => {
							hideLoading('loading_regia_map');
							document.body.style.overflowY = "";
							document.body.style.position = "";
						}
					}
				}]);
		}

		function receiveRegiaData(event) {
			if (event.origin !== regia_domain) {
				return;
			}
			const instance = Fancybox.getInstance();
			if (instance) {
				instance.close();
			}
			if (event.data) {
				var result = event.data.data;
				showDistance(result.x, result.y);
			}
		}

		window.addEventListener('message', receiveRegiaData, false);

		function showDistance(x, y, type) {
			if (typeof distance_url !== 'string') {
				return false;
			}
			type = typeof type == 'undefined' ? '' : type;
			showLoading('loading_text');
			$.ajax({
				type: 'GET',
				url: distance_url,
				data: {x: x, y: y, type: type},
				success: function (resp) {
					if (resp.success) {
						// Gavus atstumą iš žemėlapio / GPS – perskaičiuojama automatiškai
						$scope.$apply(function () {
							$scope.distanceInput = String(resp.distance).replace('.', ',');
							$scope.calculateGasConnection();
						});
					} else {
						$scope.$apply(function () {
							$scope.calcState = 'error';
							$scope.errorMsg = resp.message || self.getT('err_invalid_value');
						});
					}
				},
				error: function (xhr, ajaxOptions, thrownError) {
					$scope.$apply(function () {
						$scope.calcState = 'error';
						$scope.errorMsg = 'Distance request error: ' + xhr.status + ' ' + thrownError;
					});
				},
				complete: function () {
					hideLoading('loading_text');
					hideLoading('loading_regia_map');
				}
			});
		}

		function openRegiaByGps() {
			if (!('geolocation' in navigator)) {
				$scope.$apply(function () {
					$scope.calcState = 'error';
					$scope.errorMsg = self.getT('err_geolocation');
				});
				return false;
			}
			navigator.geolocation.getCurrentPosition(
					function (pos) {
						self.cache.latitude = pos.coords.latitude;
						self.cache.longitude = pos.coords.longitude;
						showDistance(self.cache.latitude, self.cache.longitude, 'latlng');
					},
					function () {
						if (typeof (self.cache.latitude) !== 'undefined' && typeof (self.cache.longitude) !== 'undefined') {
							showDistance(self.cache.latitude, self.cache.longitude, 'latlng');
						} else {
							$scope.$apply(function () {
								$scope.calcState = 'error';
								$scope.errorMsg = self.getT('err_geolocation');
							});
						}
					}
			);
		}

		function showLoading(text_id) {
			var id = 'calc-loading';
			if ($('#' + id).length) {
				return;
			}
			$('body').append('<div id="' + id + '" class="' + text_id + '"><div>' + self.getT(text_id) + '</div></div>');
		}

		function hideLoading(text_id) {
			text_id = (typeof text_id === 'string') ? '.' + text_id : '';
			$('#calc-loading' + text_id).remove();
		}

		// Half-up apvalinimas iki nurodyto skaičiaus skaitmenų po kablelio
		function roundHalfUp(value, decimals) {
			var factor = Math.pow(10, decimals);
			// Pridėti Number.EPSILON, kad išvengti dvejetainio plūduriavimo paklaidų (pvz. 884.415 → 884.42)
			return Math.round((value + Number.EPSILON) * factor) / factor;
		}

		function formatMoney(value) {
			return roundHalfUp(value, 2).toFixed(2).replace('.', ',');
		}

		function formatDistance(value) {
			return String(value).replace('.', ',');
		}

		// FR-2.2 submit-time validacija: leading separator (`,5`, `.5`) ir 2 separatoriai
		function validateDistanceInput(raw) {
			if (typeof raw !== 'string' || raw === '') {
				return null;
			}
			if (/^[.,]/.test(raw)) {
				return self.getT('err_invalid_value');
			}
			var sepCount = (raw.match(/[.,]/g) || []).length;
			if (sepCount > 1) {
				return self.getT('err_invalid_value');
			}
			return null;
		}

		$scope.calculateGasConnection = function () {
			$scope.errorMsg = '';
			var raw = ($scope.distanceInput || '').trim();

			var validationError = validateDistanceInput(raw);
			if (validationError) {
				$scope.calcState = 'error';
				$scope.errorMsg = validationError;
				return;
			}

			var distance = parseFloat(raw.replace(',', '.'));
			if (isNaN(distance) || distance < 0) {
				$scope.calcState = 'error';
				$scope.errorMsg = self.getT('err_invalid_value');
				return;
			}

			var res = computeGasConnection(distance, {
				rateFirstMeter: rates.rate_first_meter,
				ratePerMeter: rates.rate_per_meter,
				vatPercent: vatPercent
			}, distanceMax);

			$scope.distance = raw;
			$scope.distanceLabel = formatDistance(distance);
			$scope.calcState = res.state;

			if (res.state === 'result') {
				$scope.priceWithoutVat = formatMoney(res.priceWithoutVat);
				$scope.priceWithVat = formatMoney(res.priceWithVat);
			} else if (res.state === 'error') {
				$scope.errorMsg = self.getT('err_invalid_value');
			}
			// res.state === 'warning' (A > distance_max): TPL rodo gc-alert--warning (statinis tekstas)
		};
	}]);
